
import Wrapper from '@/components/MdxViewer';
import RoundBox from '@/snippets/RoundBox';
import { Box, Button, Container, Typography } from '@mui/material';

import { getProjectData } from '../data';

const View = (props: any) => {
    const slug = props.slug;
    const projectData = getProjectData(slug);

    const renderContent = () => {
        if (projectData.markdown) {
            return (
                <RoundBox variant="top" darken={.3} zIndex={2} bgcolor='background'>
                    <Container maxWidth="lg">
                        <Box py={15}>
                            <Wrapper
                                filePath={projectData.filePath}
                                Component={projectData.markdown} />
                        </Box>
                    </Container>
                </RoundBox>
            )
        }

        const Component = projectData.jsx;
        return <Component />
    }

    return (
        <Box>
            <RoundBox variant="top" darken={.1} zIndex={1} shift bgcolor='background'>
                <Container maxWidth="lg">
                    <Box py={10}>
                        <Typography variant="h1" align="center" gutterBottom>
                            {projectData.title}
                        </Typography>
                        <Typography variant="body1" align="center" gutterBottom>
                            {projectData.description}
                        </Typography>

                        {projectData.info?.url && (
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 5,
                                pt: 10,
                            }}>
                                <Button
                                    sx={{
                                        borderRadius: '100px',
                                    }}
                                    disableElevation
                                    variant="contained"
                                    color="secondary"
                                    href={projectData.info.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Visit Website
                                </Button>
                            </Box>
                        )}

                    </Box>

                </Container>
            </RoundBox>
            <RoundBox variant="top" darken={.2} zIndex={2} shift bgcolor='background'>
                <Container maxWidth="lg">
                    <Box sx={{
                        py: 10,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 5,
                    }}>
                        {projectData.info?.stack.map((item: any, index: number) => (
                            <Typography key={index} variant="subtitle2" color="text.secondary">
                                {item}
                            </Typography>
                        ))}
                    </Box>

                </Container>
            </RoundBox>

            {renderContent()}

        </Box>
    )
};

export default View;
